import React, { useEffect } from 'react'
import { Table } from 'antd'
import styles from './index.module.scss'

const CustomTable = <RecordType extends object = any>(props: any) => {
  const { scroll, ...restProps } = props

  useEffect(() => {
    const timeout = setTimeout(() => {
      const wrapper = document.querySelector(`.${styles.wrapper}`) as HTMLDivElement | null

      const tableBody = wrapper?.querySelector('.ant-table-body') as HTMLDivElement | null

      const fixedRightCells = wrapper?.querySelectorAll(
        'th.ant-table-cell-fix-right-first',
      ) as NodeListOf<HTMLTableCellElement> | null
      if (tableBody) {
        const hasVerticalScroll = tableBody.scrollHeight > tableBody.clientHeight
        tableBody.style.overflowY = hasVerticalScroll ? 'auto' : 'hidden'
        if (fixedRightCells) {
          fixedRightCells.forEach((th) => {
            th.style.right = hasVerticalScroll ? '5px' : '0px'
          })
        }
      }
    }, 100)

    return () => clearTimeout(timeout)
  }, [props.dataSource])

  return (
    <div className={styles.wrapper}>
      <Table<RecordType> {...restProps} scroll={scroll} />
    </div>
  )
}

export default CustomTable
